import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Link } from 'react-router-dom'
import { toast } from 'react-toastify';

import { Container, Row, Col, Card, CardBody, Label, FormGroup, Button, Alert } from 'reactstrap';
import { AvForm, AvField, AvGroup, AvInput, AvFeedback } from 'availity-reactstrap-validation';

import { signInRequest } from '~/store/modules/auth/actions';
import Loader from '~/components/Loader/Loader';
import logo from '~/assets/img/logo_corridaperfeita_azul.png';

class Login extends Component {
    _isMounted = false;

    constructor(props) {
        super(props);

        this.handleValidSubmit = this.handleValidSubmit.bind(this);
        this.state = {
            email: '',
            password: ''
        }

    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * Handles the submit
     */
    handleValidSubmit = (event, values) => {
        this.props.signInRequest(values.email, values.password);
    }


    /**
     * Redirect to root
     */
    renderRedirectToRoot = () => {
        const isAuthTokenValid = this.props.signed;
        if (isAuthTokenValid) {
            return <Redirect to='/' />
        }
    }

    render() {
        const isAuthTokenValid = this.props.signed;
        return (
            <React.Fragment>

                {this.renderRedirectToRoot()}

                {(this._isMounted || !isAuthTokenValid) && <div className="account-pages mt-5 mb-5">
                    <Container>
                        <Row className="justify-content-center">
                            <Col lg={5}>
                                <Card>
                                    <CardBody className="p-4 position-relative">
                                        <div className="text-center w-75 m-auto">
                                            <a href="/">
                                                <span><img src={logo} alt="" height="48" /></span>
                                            </a>
                                            <p className="text-muted mb-4 mt-3">Área administrativa, entre com seu e-mail e senha</p>
                                        </div>


                                        { /* preloader */}
                                        {this.props.loading && <Loader />}

                                        {this.props.error && <Alert color="danger" isOpen={this.props.error ? true : false}>
                                            <div>{this.props.error}</div>
                                        </Alert>}

                                        <AvForm onValidSubmit={this.handleValidSubmit}>

                                            <AvGroup>
                                                <Label for="password">Email</Label>
                                                <AvField type="email" name="email" id="email" placeholder="Seu e-mail" value={this.state.email} required />
                                                <AvFeedback>Campo inválido</AvFeedback>
                                            </AvGroup>

                                            <AvGroup>
                                                <Label for="password">Password</Label>
                                                <AvInput type="password" name="password" id="password" placeholder="Sua senha" value={this.state.password} required />
                                                <AvFeedback>This field is invalid</AvFeedback>
                                            </AvGroup>

                                            <FormGroup>
                                                <Button style={{background: '#081C39'}} className="btn-block">Entrar</Button>
                                            </FormGroup>

                                            {/* <p><strong>email:</strong> test &nbsp;&nbsp; <strong>Password:</strong> test</p> */}
                                        </AvForm>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        <Row className="mt-1">
                            <Col className="col-12 text-center">
                                <p><Link onClick={() => toast.warn('Contate o suporte.')} className="text-muted ml-1">Esqueceu sua senha?</Link></p>
                                {/* <p className="text-muted">Não tem conta? <Link to="/register" className="text-primary font-weight-medium ml-1"><b>Registrar</b></Link></p> */}
                            </Col>
                        </Row>

                    </Container>
                </div>}
            </React.Fragment>
        )
    }
}


const mapStateToProps = (state) => {
    // const { user, loading, error } = state.Auth;
    
    const { signed, loading } = state.auth;

    // return { user, loading, error, signed };
    return { signed, loading }
};

export default connect(mapStateToProps, { signInRequest })(Login);
 